import React from "react";

import styled from "styled-components";
import { media } from "./_includes/Device";

import { GetCookie } from "../utils/utils";

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  max-width: 1600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  > .content {
    padding-right: 60px;
    color: white;
  }
`;

const Banner = styled.div`
  position: fixed;
  top: 100px;
  width: 100%;
  z-index: 10;
  background: #06bd72;
  color: white;
  transition: all 0.3s ease-in-out;
  border-top: 1px solid rgba(0, 0, 0, 0);
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  transition: all 0.3s ease-in-out;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }

  b {
    text-decoration: underline;
  }

  &.white-header {
    background: white;
    border-top: 1px solid #f8f8f8;
    border-bottom: 1px solid #f8f8f8;
  }

  ${media.phone`    
    div {
      font-size: 14px;
    }
  `}
`;

const BannerClose = styled.span`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover,
  &:focus {
    &:after {
      opacity: 1;
    }
  }

  &:after {
    font-family: "Iconfont" !important;
    content: "\\e907";
    font-size: 18px;
    color: white;
    opacity: 0.5;
    transition: all 0.2s ease-in-out;
  }
`;

export class JobBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bannerActive: true,
    };
  }

  bannerCloser = e => {
    e.preventDefault(); // Don't trigger parent link

    this.setState({ bannerActive: false });
  };

  setBannerCookie = () => {
    if (this.state.bannerSeen !== true) {
      let date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours in the future

      document.cookie =
        "banner_seen=true; expires=" + date.toUTCString() + "; path=/";

      this.setState({ bannerSeen: true });
    }
  };

  componentDidMount() {
    let bannercheck = GetCookie("banner_seen") === "true"; // Turns cookie into true boolean
    this.setBannerCookie();
    this.setState({ bannerSeen: bannercheck });
  }

  render() {
    return (
      <Banner className={this.state.bannerActive ? "active" : "hide"}>
        <Container>
          <div className={"content"}>
            Picnic cares about your health and safety, so no worries; the recruitment process is online. You can start remote and join us in Amsterdam when it's safe to do so.
          </div>

          <BannerClose onClick={this.bannerCloser} />
        </Container>
      </Banner>
    );
  }
}
